<!-- 结算操作 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left" style="padding-top: 10px">
                <div class="flex">
                    <div class="search-name">支付方式</div>
                    <el-select class="search-name" style="width: 158px" size="small" v-model="submitData.PayType" placeholder="请选择">
                        <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">可用预付款</div>
                    <el-input-number
                        disabled
                        style="width: 140px"
                        class="search-item"
                        size="small"
                        v-model="advanceMoney"
                        :precision="2"
                        :controls="false"
                    ></el-input-number>
                    <div class="search-name">减付金额</div>
                    <el-input-number
                        style="width: 140px"
                        class="search-item"
                        size="small"
                        v-model.trim="submitData.ReduceMoney"
                        :precision="2"
                        :controls="false"
                    ></el-input-number>
                    <div class="search-name">本次欠款总额</div>
                    <el-input disabled style="width: 150px" class="search-item" size="small" v-model="total"></el-input>
                </div>
                <div class="flex">
                    <div class="search-name">结帐日期</div>
                    <el-date-picker
                        style="width: 158px"
                        class="search-name"
                        size="small"
                        v-model="submitData.PayDate"
                        align="right"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                    <div class="search-name">预付款支付</div>
                    <el-input-number
                        style="width: 140px"
                        class="search-item"
                        size="small"
                        v-model.trim="submitData.AdvanceMoney"
                        :precision="2"
                        :controls="false"
                    ></el-input-number>
                    <div class="search-name">备注</div>
                    <el-input style="width: 423px" class="search-item" size="small" v-model.trim="submitData.Remark" placeholder="请输入备注"></el-input>
                </div>
            </div>
        </div>
        <div class="table-ctn applydata-edit">
            <ux-grid
                border
                show-overflow
                ref="plxTable"
                keep-source
                height="400"
                :highlightCurrentRow="false"
                :data="tableData"
                :edit-config="{ trigger: 'click', mode: 'cell' }"
                style="width: 100%; margin-bottom: 10px"
            >
                <ux-table-column class-name="table-sort" type="index" width="60" title="序号"></ux-table-column>
                <ux-table-column class-name="table-sort" show-overflow-tooltip width="180" field="OrderCode" title="单号"></ux-table-column>
                <ux-table-column class-name="table-sort" width="90" field="OrderType" title="单据类型">
                    <template slot-scope="scope">
                        <i v-if="scope.row.OrderType == 0" class="c-active">采购付款</i>
                        <i v-else-if="scope.row.OrderType == 1" class="out-active">采购退货</i>
                        <i v-else-if="scope.row.OrderType == 2">合并帐</i>
                        <i v-else>建账</i>
                    </template>
                </ux-table-column>
                <ux-table-column class-name="table-sort" show-overflow-tooltip width="90" field="TotalAmount" title="应付总额">
                    <template slot-scope="scope">{{ scope.row.OrderType != 1 ? scope.row.TotalAmount : -scope.row.TotalAmount }}</template>
                </ux-table-column>
                <ux-table-column class-name="table-sort" show-overflow-tooltip width="90" field="Balance" title="欠款余额"> </ux-table-column>
                <ux-table-column field="name" title="本次付款" width="100" :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.NowPay || row.NowPay === 0 }]">{{ row.NowPay }}</div>
                    </template>
                    <template v-slot:edit="scope"
                        ><el-input-number style="width: 100%" size="small" :controls="false" v-model="scope.row.NowPay"></el-input-number>
                    </template>
                </ux-table-column>
                <ux-table-column class-name="table-sort" show-overflow-tooltip min-width="90" field="Remark" title="备注"></ux-table-column>
                <ux-table-column title="操作" width="60">
                    <template v-slot="{ row }">
                        <el-button title="移除" size="small" type="text" @click="delItem(row)" style="color: red">移除</el-button>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <div class="dialog-footer">
            <div class="re-submit">
                <el-button class="btn-primary" @click="submitForm()">提交</el-button>
                <el-button @click="cancel()">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['ApplyList'],
    components: {},
    data() {
        return {
            loading: false,
            dateTimes: [],
            submitData: {
                Records: [],
                PayDate: '',
                PayType: '',
                ReduceMoney: 0,
                AdvanceMoney: 0,
                OPType: 1,
                Remark: ''
            },
            entpCusId: '',
            total: 0,
            advanceMoney: 0,
            payWayList: [],
            tableData: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    },
                    {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created: function () {
        var aData = new Date();
        this.submitData.PayDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate();
    },
    mounted() {
        if (this.ApplyList && this.ApplyList.length > 0) {
            this.getPay();
            this.tableData = this.ApplyList;
            let _total = 0;
            for (let index = 0; index < this.tableData.length; index++) {
                if (!this.entpCusId) {
                    this.entpCusId = this.tableData[index].EntpCusId;
                }
                let b = (this.tableData[index].TotalAmount - this.tableData[index].AlreadyPaid).toFixed(2);
                if (this.tableData[index].OrderType != 1) {
                    this.tableData[index].Balance = b;
                    this.tableData[index].NowPay = b;
                    _total += Number(b);
                } else {
                    this.tableData[index].Balance = -b;
                    this.tableData[index].NowPay = -b;
                    _total -= b;
                }
            }
            this.total = _total.toFixed(2);
            if (this.entpCusId) this.GetCusAdvanceMoney();
        } else this.$util.warningMsg('付款数据异常，请刷新后重新操作');
    },
    methods: {
        GetCusAdvanceMoney() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/RevenueManagement_H/GetCusAdvanceMoney',
                    data: { CusId: that.entpCusId },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) that.advanceMoney = data;
                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        submitForm() {
            let that = this;
            if (that.loading) return;
            //先清空防止重复添加
            that.submitData.Records = [];
            if (!that.submitData.PayType) {
                that.$util.warningMsg('请选择支付方式');
                return;
            }
            if (!that.submitData.ReduceMoney && that.submitData.ReduceMoney != 0) {
                that.$util.warningMsg('减付金额必须为数字类型');
                return;
            } else if (isNaN(that.submitData.ReduceMoney)) {
                that.$util.warningMsg('减付金额必须为数字类型');
                return;
            }
            if (isNaN(that.submitData.AdvanceMoney)) {
                that.$util.warningMsg('预付款支付金额必须为数字类型');
                return;
            } else if (that.submitData.AdvanceMoney > that.advanceMoney) {
                that.$util.warningMsg('预付款支付金额不能大于可用预付款金额');
                return;
            }
            if (that.submitData.AdvanceMoney > that.total - that.submitData.ReduceMoney && that.submitData.AdvanceMoney !== 0) {
                that.$util.warningMsg('预付款支付金额不能大于总可付欠款金额');
                return;
            }
            for (let index = 0; index < this.tableData.length; index++) {
                // if (this.tableData[index].NowPay === 0) {
                //     that.$util.warningMsg('本次收取金额不能等于0');
                //     return;
                // }
                let _nowPay = Number(this.tableData[index].NowPay).toFixed(2);
                let b = (this.tableData[index].TotalAmount - this.tableData[index].AlreadyPaid).toFixed(2);
                if (this.tableData[index].OrderType == 0) {
                    if (+_nowPay > +b) {
                        that.$util.warningMsg('采购单号【' + this.tableData[index].OrderCode + '】本次付款金额不能大于欠款余额');
                        return;
                    }
                } else if (this.tableData[index].OrderType == 1) {
                    if (+_nowPay < -b) {
                        that.$util.warningMsg('退货单号【' + this.tableData[index].OrderCode + '】本次付款金额不能小于欠款余额');
                        return;
                    }
                }

                let d = {
                    RecordId: this.tableData[index].RecordId,
                    NowPay: _nowPay,
                    OrderCode:this.tableData[index].OrderCode
                };
                this.submitData.Records.push(d);
            }
            if (that.submitData.Records.length == 0) {
                that.$util.warningMsg('必须具备付款条目');
                return;
            }
            that.loading = true;
            that.$util
                .axiosPost({
                    url: '/api/RevenueManagement_H/SubmitSupSettlementDatas',
                    data: that.submitData,
                    hideLoading: true
                })
                .then(res => {
                    that.$util.successMsg(res.errmsg);
                    if (res.errcode === 0) {
                        that.$emit('closeDialog', true);
                    }
                })
                .finally(() => {
                    that.submitData.Records = [];
                    that.loading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        delItem(item) {
            let that = this;
            if (item) {
                that.tableData.splice(that.tableData.indexOf(item), 1);
                let _total = 0;
                for (let index = 0; index < that.tableData.length; index++) {
                    if (this.tableData[index].Source !== 3) {
                        if (this.tableData[index].OrderType != 1) {
                            let b = Number(this.tableData[index].TotalAmount - this.tableData[index].AlreadyPaid);
                            _total += b;
                        } else {
                            let b = Number(this.tableData[index].TotalAmount - this.tableData[index].AlreadyPaid);
                            _total -= b;
                        }
                    } else {
                        if (this.tableData[index].OrderType != 1) {
                            let b = Number(this.tableData[index].AgentAmount - this.tableData[index].AlreadyPaid);
                            _total += b;
                        } else {
                            let b = Number(this.tableData[index].AgentAmount - this.tableData[index].AlreadyPaid);
                            _total -= b;
                        }
                    }
                }
                this.total = _total.toFixed(2);
            }
        },
        //  结算方式
        getPay() {
            this.$util.getPay(1).then(data => {
                this.payWayList = data;
            });
        }
    }
};
</script>
<style lang="less" scoped>
.re-submit {
    text-align: right;
}
</style>
<style lang="less">
.applydata-edit {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 10px 0;
                    }
                }

                .div-padding-12 {
                    padding: 4px 8px 0;
                }

                .special-border {
                    height: 100%;
                    border-radius: 3px;
                    border: 1px solid #ffcc00;
                }

                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }

                .operate {
                    padding: 0 12px;
                }

                td {
                    height: 26px;
                }
            }

            .elx-cell {
                padding: 0;
                height: 32px;
            }

            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }

        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }

    .el-input {
        .el-input__inner {
            padding-right: 20px;
        }
    }
}
</style>
